import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/story_groups'

const CmsStoryGroupApiV2 = {

  /**
   * Get list of Cms Story Group
   * Invoke `GET api/v2/admins/cms/story_groups'
   */
  get: async ({ filters }) => {
    const path     = API_PATH
    const params   = {
      page     : filters?.page,
      per_page : filters?.per_page,
      title    : filters?.title
    }
    const response = await axios.get(path, { params })
    return response
  },

  /**
   * Create Cms Story Group
   * Invoke `POST api/v2/admins/cms/story_groups'
   */
  create: async ({ params }) => {
    const path        = API_PATH
    params.starts_at  = [
      params.starts_at,
      params.starts_time
    ].join(' ')
    params.expires_at = [
      params.expires_at,
      params.expires_time
    ].join(' ')
    const payload     = {
      story_group: params
    }
    const response    = await axios.post(path, payload)
    return response
  },

  /**
   * Update Cms Story Group
   * Invoke `PATCH api/v2/admins/cms/story_groups/:id'
   */
  update: async ({ id, params }) => {
    const path        = `${API_PATH}/${id}`
    params.starts_at  = [ params.starts_at, params.starts_time ].join(' ')
    params.expires_at = [ params.expires_at, params.expires_time ].join(' ')
    const payload     = {
      story_group: params
    }
    const response    = await axios.patch(path, payload)
    return response
  },

  /**
   * Get Cms Story Group by id
   * Invoke `GET api/v2/admins/cms/story_groups/:id'
   */
  show: async ({ id }) => {
    const path     = `${API_PATH}/${id}`
    const response = await axios.get(path)
    return response
  }

}

export default CmsStoryGroupApiV2
